<template>
  <a href="#!"
     class="btn module-color-background"
     model="action" :model-id="action.id"
     :loading="'.action'+action.id"
     @click="$emit('click')"
  >
    {{ actionButtonTitle }}
  </a>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ActionButton',
  props: {
    action: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      actionStatuses: 'settings/getActionStatuses',
      dynamicActionTypes: 'settings/getDynamicActionTypes',
    }),
    getCurrentStatus() {
      if (!this.action || !this.action.action_status_id || !this.actionStatuses[this.action.action_status_id]) {
        return {};
      }
      return this.actionStatuses[this.action.action_status_id];
    },
    getCurrentType() {
      if (!this.action || !this.action.dynamic_action_type_id || !this.dynamicActionTypes[this.action.dynamic_action_type_id]) {
        return {};
      }
      return this.dynamicActionTypes[this.action.dynamic_action_type_id];
    },
    actionButtonTitle() {
      if (this.action.date_interval) {
        return this.$options.filters.capitalize(this.$t('actionlog.edit'));
      }
      if (this.getCurrentStatus) {
        if (this.getCurrentStatus.is_final) {
          return this.$options.filters.capitalize(this.$t('actionlog.show'));
        }
      }
      if (this.getCurrentType) {
        if (this.getCurrentType.creates_object) {
          return this.$options.filters.capitalize(this.$t('actionlog.place'));
        }
        if (this.getCurrentType.deletes_object) {
          return this.$options.filters.capitalize(this.$t('actionlog.delete'));
        }
        if (this.getCurrentType.dynamicActionTypeCategory
          && this.getCurrentType.dynamicActionTypeCategory.data) {
          if (
            this.getCurrentType.dynamicActionTypeCategory.data.is_change_request
          ) {
            return this.$options.filters.capitalize(this.$t('actionlog.change'));
          }
        }
      }
      return this.$options.filters.capitalize(this.$t('actionlog.process'));
    },
  },
};
</script>
